import type { UaSummary } from '@/api/unitAssessmentAdmin'
import type { LearnerLibraryResponse } from '@/types/coaching'

export function pickDefaultUnitAssessmentId(unitAssessments: UaSummary[], defaultLessonId: number | null): number | null {
  const active = unitAssessments.filter((ua) => ua.status !== 'COMPLETED' && ua.status !== 'CANCELLED')
  const current = active.find((ua) => ua.status !== 'PENDING')
  if (current) return current.id
  if (defaultLessonId == null) return null
  return active.find((ua) => ua.anchorLessonId === defaultLessonId)?.id ?? null
}

export function pickDefaultLibraryLessonId(library: LearnerLibraryResponse | undefined): number | null {
  if (!library) return null

  let firstInProgress: number | null = null
  let firstNotStarted: number | null = null

  for (const curriculum of library.tree) {
    for (const course of curriculum.courses) {
      for (const module of course.modules) {
        for (const lesson of module.lessons) {
          if (firstInProgress == null && lesson.status === 'in_progress') {
            firstInProgress = lesson.lessonId
          }
          if (firstNotStarted == null && lesson.status === 'not_started') {
            firstNotStarted = lesson.lessonId
          }
        }
      }
    }
  }

  return firstInProgress ?? firstNotStarted
}
